import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { InstallAppButton } from "@/components/PwaShell";
import logo from "@/assets/login-logo.png";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const Navbar = ({ variant = "solid", onLogoClick }) => {
  const { user, logout, openLogin } = useAuth();
  const initials = (user?.name?.trim()?.[0] || "T").toUpperCase();
  const transparent = variant === "transparent";

  return (
    <header
      className={
        transparent
          ? "absolute top-0 inset-x-0 z-30 bg-transparent"
          : "sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-stone-200"
      }
    >
      <div className="max-w-6xl mx-auto mobile-page-gutter px-6 md:px-10 h-16 flex items-center justify-between">
        <button type="button" onClick={onLogoClick} data-testid="app-logo" className="flex items-center cursor-pointer bg-transparent border-0 p-0">
          <img
            data-testid="app-header-logo"
            src={logo}
            alt="pik your trip"
            className={`h-14 sm:h-12 aspect-[1151/420] w-auto object-contain ${transparent ? "[filter:brightness(0)_invert(1)]" : ""}`}
          />
        </button>

        <div className="flex shrink-0 items-center gap-2">
        <InstallAppButton transparent={transparent} />
        {!user ? <button data-testid="open-login-button" onClick={openLogin} className={`rounded-full px-3 py-2 text-sm font-semibold transition-colors ${transparent ? "text-white hover:bg-white/10" : "text-stone-700 hover:bg-stone-100"}`}>Sign in</button> : <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              data-testid="user-menu-btn"
              aria-label={`Account menu for ${user?.name || "Traveler"}`}
              className={`flex items-center rounded-full p-1 transition-colors ${transparent ? "hover:bg-white/10" : "hover:bg-stone-100"}`}
            >
              {user?.picture ? (
                <img src={user.picture} alt="" className="w-8 h-8 rounded-full object-cover" referrerPolicy="no-referrer" />
              ) : (
                <span className="grid w-8 h-8 rounded-full bg-ac text-white place-items-center text-sm font-bold">{initials}</span>
              )}
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="rounded-2xl">
            <DropdownMenuLabel className="font-['Figtree']">
              <div className="font-bold text-stone-900">{user?.name || "Traveler"}</div>
              {user?.email && <div className="text-xs text-stone-500 font-normal">{user.email}</div>}
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem data-testid="logout-btn" onClick={() => logout().catch(() => toast.error("Could not sign out. Please try again."))} className="text-rose-600 focus:text-rose-600 cursor-pointer">
              <LogOut className="w-4 h-4 mr-2" /> Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>}
        </div>
      </div>
    </header>
  );
};
